import React from "react";
import Categories from "./index";

function ImportCategories() {
  return <Categories asImport={true} />;
}

export default ImportCategories;
